import { SeverityLevel } from '@sentry/react';

import { Sentry } from '@//infra/observability/sentry/instance';
import { FeaturesRequest } from '@//infra/observability/sentry/types/features';

export type Extra =
  | {
      [x: string]: unknown;
    }
  | undefined;

export function captureException<T extends Extra>(
  error: Error,
  feature: FeaturesRequest,
  extra?: T,
  level: SeverityLevel = 'error',
) {
  Sentry.captureException(error, { extra, level, tags: { feature } });
}
